export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7037.62487e18.jpg";